// extracted by mini-css-extract-plugin
export default {"input":"NumberInput_input__-9gsH","decimals":"NumberInput_decimals__Cv3S6","arrowsInputContainer":"NumberInput_arrowsInputContainer__dz2C3"};